import dashboard from 'assets/images/Dashboard.svg';
import dashboardBlue from 'assets/images/DashboardBlue.svg';
import vendor from 'assets/images/Vendor.svg';
import vendorBlue from 'assets/images/VendorBlue.svg';
import customer from 'assets/images/Customer.svg';
import customerBlue from 'assets/images/CustomerBlue.svg';
import driver from 'assets/images/Driver.svg';
import driverBlue from 'assets/images/DriverBlue.svg';
import rideTrack from 'assets/images/RideTrack.svg';
import rideTrackBlue from 'assets/images/RideTrackBlue.svg';
import support from 'assets/images/Support.svg';
import supportBlue from 'assets/images/SupportBlue.svg';
import compliance from 'assets/images/Compliance.svg';
import complianceBlue from 'assets/images/ComplianceBlue.svg';
import feedback from 'assets/images/Feedback.svg';
import feedbackBlue from 'assets/images/FeedbackBlue.svg';
import invoice from 'assets/images/Invoice.svg';
import invoiceBlue from 'assets/images/InvoiceBlue.svg';
import notification from 'assets/images/Notification.svg';
import notificationBlue from 'assets/images/NotificationBlue.svg';
import report from 'assets/images/Report.svg';
import reportBlue from 'assets/images/ReportBlue.svg';
import setting from 'assets/images/Setting.svg';
import settingBlue from 'assets/images/SettingBlue.svg';
import configuration from 'assets/images/Configure.svg';
import logout from 'assets/images/Logout.svg';
import logoutBlue from 'assets/images/LogoutBlue.svg';
import RateCard from 'assets/images/RateCard.svg';
import RateCardBlue from 'assets/images/RateCardBlue.svg';
import FAQ from 'assets/images/FAQ.svg';
import FAQBlue from 'assets/images/FAQBlue.svg';
import ComplianceConfig from 'assets/images/ComplianceConfig.svg';
import ComplianceConfigBlue from 'assets/images/ComplianceConfigBlue.svg';
import ConfigVehicle from 'assets/images/ConfigVehicle.svg';
import ConfigVehicleBlue from 'assets/images/ConfigVehicleBlue.svg';
import FeebackConfig from 'assets/images/FeedbackConfig.svg';
import FeebackConfigBlue from 'assets/images/FeedbackConfigBlue.svg';
import Booking from "assets/images/Booking Inactive.svg"
import BookingBlue from "assets/images/Booking Active.svg"

export const sideData = [
  {
    id: 0,
    field: 'Dashboard',
    path: 'dashboard',
    icon: dashboard,
    activeIcon: dashboardBlue,
  },
  {
    id: 1,
    field: 'City Manager',
    path: 'vendor',
    icon: vendor,
    activeIcon: vendorBlue,
  },
  // {
  //   id: 21,
  //   field: 'Assign',
  //   path: '',
  //   icon: vendor,
  //   activeIcon: vendorBlue,
  //   submenu: [
  //     {
  //       id: 22,
  //       field: 'Assign Trip',
  //       path: 'assigntrip',
  //       icon: compliance,
  //       activeIcon: complianceBlue,
  //     },
  //     {
  //       id: 23,
  //       field: 'Assign Vehicle',
  //       path: 'assignvechile',
  //       icon: compliance,
  //       activeIcon: complianceBlue,
  //     },
  //     {
  //       id: 24,
  //       field: 'Assign Driver',
  //       path: 'assigndriver',
  //       icon: compliance,
  //       activeIcon: complianceBlue,
  //     },
  //   ],
  // },
  {
    id: 2,
    field: 'Customers',
    path: 'customer',
    icon: customer,
    activeIcon: customerBlue,
  },
  // {
  //   id: 3,
  //   field: 'Drivers',
  //   path: 'driver',
  //   icon: driver,
  //   activeIcon: driverBlue,
  // },
  {
    id: 4,
    field: 'Track Trip',
    path: 'rideTrack',
    icon: rideTrack,
    activeIcon: rideTrackBlue,
  },
  {
    id: 5,
    field: 'Support console',
    path: 'support',
    icon: support,
    activeIcon: supportBlue,
  },
  {
    id: 6,
    field: 'Compliance',
    path: 'compliance',
    icon: compliance,
    activeIcon: complianceBlue,
  },
  {
    id: 7,
    field: 'Feedback',
    path: 'feedback',
    icon: feedback,
    activeIcon: feedbackBlue,
  },
  {
    id: 8,
    field: 'Reports',
    path: 'reports',
    icon: report,
    activeIcon: reportBlue,

    submenu: [
      {
        id: 40,
        field: "Booking",
        path: "reports/booking",
        icon: Booking,
        activeIcon: BookingBlue,
      },
      // {
      //   id: 41,
      //   field: "Customer",
      //   path: "reports/customer",
      //   icon: report,
      //   activeIcon: reportBlue,
      // }
    ]
  },
  {
    id: 9,
    field: 'Configuration',
    path: 'configuration',
    icon: configuration,
    activeIcon: complianceBlue,
    
    submenu: [
      {
        id:20,
        field:"Rate Card",
        path:"ratecard",
        icon: RateCard,
        activeIcon: RateCardBlue,
      },
      {
        id: 14,
        field: 'Compliance',
        path: 'addcomplaince',
        icon: ComplianceConfig,
        activeIcon: ComplianceConfigBlue,
      },
      {
        id: 15,
        field: 'Feedback',
        path: 'addfeedback',
        icon: FeebackConfig,
        activeIcon: FeebackConfigBlue,
      },
      {
        id: 16,
        field: 'Vehicle Category',
        path: 'addcabcategory',
        icon: ConfigVehicle,
        activeIcon: ConfigVehicleBlue,
      },
      // {
      //   id:17,
      //   field:"Add Facilities",
      //   path:"addfacilities",
      // },
      {
        id: 18,
        field: 'FAQs',
        path: 'faq',
        icon: FAQ,
        activeIcon: FAQBlue,
      },
      // {
      //   id:19,
      //   field:"Policy",
      //   path:"policy",
      // },
    ],
  },
  {
    id: 10,
    field: 'Invoice',
    path: 'invoice',
    icon: invoice,
    activeIcon: invoiceBlue,
  },
  {
    id: 11,
    field: 'Notification',
    path: 'notification',
    icon: notification,
    activeIcon: notificationBlue,
  },

  {
    id: 12,
    field: 'Settings',
    path: 'settings',
    icon: setting,
    activeIcon: settingBlue,
  },
  {
    id: 13,
    field: 'Logout',
    path: '',
    icon: logout,
    activeIcon: logoutBlue,
  },
];

// ---Vendor Side Data---
export const vendorSideData = [
  {
    id: 0,
    field: 'Dashboard',
    path: 'dashboard',
    icon: dashboard,
    activeIcon: dashboardBlue,
  },
  {
    id: 1,
    field: 'Assign',
    path: '',
    icon: vendor,
    activeIcon: vendorBlue,
    submenu: [
      {
        id: 18,
        field: 'Assign Trip',
        path: 'assigntrip',
        icon: rideTrack,
        activeIcon: complianceBlue,
      },
      {
        id: 19,
        field: 'Assign Vehicle',
        path: 'assignvechile',
        icon: driver,
        activeIcon: complianceBlue,
      },
      {
        id: 20,
        field: 'Assign Driver',
        path: 'assigndriver',
        icon: driver,
        activeIcon: complianceBlue,
      },
    ],
  },
  {
    id: 2,
    field: 'Sub-Vendor',
    path: 'subvendor',
    icon: customer,
    activeIcon: customerBlue,
  },
  {
    id: 3,
    field: 'Own Drivers',
    path: 'driver',
    icon: driver,
    activeIcon: driverBlue,
  },
  {
    id: 17,
    field: 'Vehicle',
    path: 'Vehicle',
    icon: driver,
    activeIcon: driverBlue,
  },
  {
    id: 4,
    field: 'Track Trip',
    path: 'rideTrack',
    icon: rideTrack,
    activeIcon: rideTrackBlue,
  },
  {
    id: 5,
    field: 'Support console',
    path: 'support',
    icon: support,
    activeIcon: supportBlue,
  },
  {
    id: 6,
    field: 'Compliance',
    path: 'compliance',
    icon: compliance,
    activeIcon: complianceBlue,
  },
  {
    id: 7,
    field: 'Feedback',
    path: 'feedback',
    icon: feedback,
    activeIcon: feedbackBlue,
  },
  {
    id: 8,
    field: 'Reports',
    path: 'reports',
    icon: report,
    activeIcon: reportBlue,
    submenu: [
      {
        id: 40,
        field: "Booking",
        path: "reports/booking",
        icon: report,
        activeIcon: reportBlue,
      },
      // {
      //   id: 41,
      //   field: "Customer",
      //   path: "reports/customer",
      //   icon: report,
      //   activeIcon: reportBlue,
      // }
    ]
  },
  {
    id: 10,
    field: 'Invoice',
    path: 'invoice',
    icon: invoice,
    activeIcon: invoiceBlue,
  },
  {
    id: 11,
    field: 'Notification',
    path: 'notification',
    icon: notification,
    activeIcon: notificationBlue,
  },

  {
    id: 12,
    field: 'Settings',
    path: 'settings',
    icon: setting,
    activeIcon: settingBlue,
  },
  {
    id: 13,
    field: 'Logout',
    path: '',
    icon: logout,
    activeIcon: logoutBlue,
  },
];

// ---Customer Side Data---
export const customerSideData = [
  {
    id: 0,
    field: 'Dashboard',
    path: 'dashboard',
    icon: dashboard,
    activeIcon: dashboardBlue,
  },
  {
    id: 1,
    field: 'Customer',
    path: 'customer',
    icon: vendor,
    activeIcon: vendorBlue,
  },
  {
    id: 2,
    field: 'Track Trip',
    path: 'rideTrack',
    icon: rideTrack,
    activeIcon: rideTrackBlue,
  },
  {
    id: 3,
    field: 'Support console',
    path: 'support',
    icon: support,
    activeIcon: supportBlue,
  },
  {
    id: 4,
    field: 'Feedback',
    path: 'feedback',
    icon: feedback,
    activeIcon: feedbackBlue,
  },
  {
    id: 5,
    field: 'Configuration',
    path: '',
    icon: vendor,
    activeIcon: vendorBlue,
    submenu: [
      {
        id: 6,
        field: 'FAQs',
        path: 'faq',
        icon: compliance,
        activeIcon: complianceBlue,
      },
    ],
  },
  {
    id: 9,
    field: 'Reports',
    path: 'reports',
    icon: report,
    activeIcon: reportBlue,
  },
  {
    id: 10,
    field: 'Invoice',
    path: 'invoice',
    icon: invoice,
    activeIcon: invoiceBlue,
  },
  {
    id: 11,
    field: 'Notification',
    path: 'notification',
    icon: notification,
    activeIcon: notificationBlue,
  },

  {
    id: 12,
    field: 'Settings',
    path: 'settings',
    icon: setting,
    activeIcon: settingBlue,
  },
  {
    id: 13,
    field: 'Logout',
    path: '',
    icon: logout,
    activeIcon: logoutBlue,
  },
];


// ---Sub-Vendor Data---

export const subVendorSideData = [
  {
    id: 0,
    field: 'Dashboard',
    path: 'dashboard',
    icon: dashboard,
    activeIcon: dashboardBlue,
  },
  {
    id: 19,
    field: 'Assign Vehicle',
    path: 'assignvechile',
    icon: driver,
    activeIcon: dashboardBlue,
  },
  {
    id: 4,
    field: 'Track Trip',
    path: 'rideTrack',
    icon: rideTrack,
    activeIcon: rideTrackBlue,
  },
  {
    id: 3,
    field: 'Own Drivers',
    path: 'driver',
    icon: driver,
    activeIcon: driverBlue,
  },
  // For subvendor its not required now
  // {
  //   id: 1,
  //   field: 'Assign',
  //   path: '',
  //   icon: vendor,
  //   activeIcon: vendorBlue,
  //   submenu: [
  //     {
  //       id: 18,
  //       field: 'Assign Trip',
  //       path: 'assigntrip',
  //       icon: rideTrack,
  //       activeIcon: dashboardBlue,
        
  //     },
  //     {
  //       id: 19,
  //       field: 'Assign Vehicle',
  //       path: 'assignvechile',
  //       icon: driver,
  //       activeIcon: dashboardBlue,
  //     },
  //   ],
  // },
  {
    id: 17,
    field: 'Vehicle',
    path: 'Vehicle',
    icon: driver,
    activeIcon: driverBlue,
  },
  // {
  //   id: 5,
  //   field: 'Support console',
  //   path: 'support',
  //   icon: support,
  //   activeIcon: supportBlue,
  // },
  {
    id: 6,
    field: 'Compliance',
    path: 'compliance',
    icon: compliance,
    activeIcon: complianceBlue,
  },
  // {
  //   id: 7,
  //   field: 'Feedback',
  //   path: 'feedback',
  //   icon: feedback,
  //   activeIcon: feedbackBlue,
  // },
  // {
  //   id: 8,
  //   field: 'Reports',
  //   path: 'reports',
  //   icon: report,
  //   activeIcon: reportBlue,

  //   submenu: [
  //     {
  //       id: 40,
  //       field: "Booking",
  //       path: "reports/booking",
  //       icon: report,
  //       activeIcon: reportBlue,
  //     },
  //     {
  //       id: 41,
  //       field: "Customer",
  //       path: "reports/customer",
  //       icon: report,
  //       activeIcon: reportBlue,
  //     }
  //   ]
  // },
  // {
  //   id: 10,
  //   field: 'Invoice',
  //   path: 'invoice',
  //   icon: invoice,
  //   activeIcon: invoiceBlue,
  // },
  // {
  //   id: 11,
  //   field: 'Notification',
  //   path: 'notification',
  //   icon: notification,
  //   activeIcon: notificationBlue,
  // },

  {
    id: 12,
    field: 'Settings',
    path: 'settings',
    icon: setting,
    activeIcon: settingBlue,
  },
  {
    id: 13,
    field: 'Logout',
    path: '',
    icon: logout,
    activeIcon: logoutBlue,
  },
];
